import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

function TermsTypography(): JSX.Element {
    const { t } = useTranslation();
    
    return (
      <>
        <Typography component="div" variant="h5" sx={{fontWeight:"bold"}}>
          {t("component.termsTypography.title")}
        </Typography>
        <Typography component="div" variant="caption">
          　
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.introduction")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.agreement.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.agreement.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.registration.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.registration.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.registrationRejection.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.registrationRejection.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.registrationRejection.items.0")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.registrationRejection.items.1")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.registrationRejection.items.2")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.minorUse.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.minorUse.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.minorUse.adulthood")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.loginManagement.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.loginManagement.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.contentUsage.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.contentUsage.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.contentUsage.termination")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.delayedPayment.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.delayedPayment.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.userPosts.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.rights")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.copyright")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.backup")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.0")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.1")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.2")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.3")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.4")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.5")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.6")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.7")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.8")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.9")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.10")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.11")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.userPosts.prohibitedContent.items.12")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.prohibitedActions.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.0")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.1")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.2")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.3")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.4")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.5")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.6")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.7")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.8")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.9")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.10")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.11")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.12")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.13")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.14")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.15")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.16")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.17")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.18")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.19")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.20")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.21")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.22")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.prohibitedActions.items.23")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.monetization.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.monetization.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.monetization.items.0")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.monetization.items.1")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.monetization.items.2")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.antisocialForces.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.declaration.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.declaration.items.0")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.declaration.items.1")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.declaration.items.2")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.declaration.items.3")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.declaration.items.4")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.declaration.items.5")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.prohibitedItems.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.prohibitedItems.items.0")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.prohibitedItems.items.1")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.prohibitedItems.items.2")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.prohibitedItems.items.3")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.antisocialForces.prohibitedItems.items.4")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.restrictions.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.restrictions.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.restrictions.items.0")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.restrictions.items.1")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.restrictions.items.2")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.restrictions.items.3")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.restrictions.items.4")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.restrictions.items.5")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.restrictions.items.6")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.serviceStop.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.serviceStop.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.serviceStop.items.0")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.serviceStop.items.1")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.serviceStop.items.2")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.serviceStop.items.3")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.withdrawal.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.withdrawal.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.disclaimer.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.disclaimer.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.exemption.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.exemption.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.exemption.consumerContent")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.exemption.limitContent")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.serviceChange.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.serviceChange.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.termsChange.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.termsChange.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.privacy.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.privacy.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.notification.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.notification.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.rightsTransfer.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.rightsTransfer.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.businessTransfer.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.businessTransfer.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.applicability.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.applicability.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.applicability.items")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.severability.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.severability.content")}
        </Typography>
        <Typography component="div" variant="body2" sx={{fontWeight:"bold" , marginTop:2}}>
          {t("component.termsTypography.governing.title")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.governing.content")}
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.governing.items")}
        </Typography>
        <Typography component="div" variant="caption">
          　
        </Typography>
        <Typography component="div" variant="caption">
          {t("component.termsTypography.dates.established")}
        </Typography>
      </>
      );
};
export default TermsTypography;